import { render, staticRenderFns } from "./PartnerProduct.vue?vue&type=template&id=a74ef2b0&scoped=true&"
import script from "./PartnerProduct.vue?vue&type=script&lang=ts&"
export * from "./PartnerProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ef2b0",
  null
  
)

export default component.exports